import * as React from 'react'
import PropTypes from 'prop-types'

import LocationAutocomplete from '../../../../../../ui/Form/components/LocationAutocomplete'
import { LocationFilterShape } from '../../../../../../models/LocationFilter'
import { Container, Column, LocationColumn, Select, Button } from './style'

const FrontPageHeaderSearch = ({
  eventTypes,
  eventType,
  onEventTypeChange,
  performLocation,
  onPerformLocationChange,
  onPerformLocationReset,
  onSubmitSearch,
}) => {
  const eventTypeOptions = React.useMemo(() => {
    const groups = []
    Object.keys(eventTypes).forEach(index => {
      const options = []
      Object.keys(eventTypes[index].sub).forEach(key => {
        options.push(
          <option key={key} value={key}>
            {eventTypes[index].sub[key].name}
          </option>,
        )
      })
      groups.push(
        <optgroup label={eventTypes[index].longName} key={index}>
          {options}
        </optgroup>,
      )
    })
    return groups
  }, [eventTypes])

  return (
    <Container>
      <Column>
        <Select
          id="frontpage-search-event-type"
          aria-label="Hva skal du arrangere?"
          value={eventType}
          onChange={onEventTypeChange}
        >
          <option value="">Hva skal du arrangere?</option>
          {eventTypeOptions}
        </Select>
      </Column>
      <LocationColumn>
        <LocationAutocomplete
          id="frontpage-search-location"
          value={performLocation}
          onChange={onPerformLocationChange}
          onReset={onPerformLocationReset}
        />
      </LocationColumn>
      <Column>
        <Button type="button" onClick={onSubmitSearch}>
          Søk
        </Button>
      </Column>
    </Container>
  )
}

FrontPageHeaderSearch.propTypes = {
  eventType: PropTypes.string,
  eventTypes: PropTypes.shape({ name: PropTypes.string }).isRequired,
  onEventTypeChange: PropTypes.func.isRequired,
  performLocation: LocationFilterShape,
  onPerformLocationChange: PropTypes.func.isRequired,
  onPerformLocationReset: PropTypes.func.isRequired,
  onSubmitSearch: PropTypes.func.isRequired,
}

FrontPageHeaderSearch.defaultProps = {
  eventType: '',
  performLocation: null,
}

export default FrontPageHeaderSearch
